// @flow

import type { Action } from './store.type';

// Boost template instance
export const SI_GET_BOOST_TEMPLATES_REQUEST = 'SI_GET_BOOST_TEMPLATES_REQUEST';
type SI_GET_BOOST_TEMPLATES_REQUEST_TYPE = 'SI_GET_BOOST_TEMPLATES_REQUEST';

export const SI_GET_BOOST_TEMPLATES_SUCCESS = 'SI_GET_BOOST_TEMPLATES_SUCCESS';
type SI_GET_BOOST_TEMPLATES_SUCCESS_TYPE = 'SI_GET_BOOST_TEMPLATES_SUCCESS';

export const SI_GET_BOOST_TEMPLATES_FAILURE = 'SI_GET_BOOST_TEMPLATES_FAILURE';
type SI_GET_BOOST_TEMPLATES_FAILURE_TYPE = 'SI_GET_BOOST_TEMPLATES_FAILURE';

type SITemplateInstanceFailure = {
  error: any
};

type SIGetBoostTemplatesRequestAction = Action<SI_GET_BOOST_TEMPLATES_REQUEST_TYPE, null>;

type SIGetBoostTemplatesSuccessAction = Action<SI_GET_BOOST_TEMPLATES_SUCCESS_TYPE, { data: any }>;

type SIGetBoostTemplatesFailureAction = Action<
  SI_GET_BOOST_TEMPLATES_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Template instance
export const SI_GET_TEMPLATE_INSTANCES_REQUEST = 'SI_GET_TEMPLATE_INSTANCES_REQUEST';
type SI_GET_TEMPLATE_INSTANCES_REQUEST_TYPE = 'SI_GET_TEMPLATE_INSTANCES_REQUEST';

export const SI_GET_TEMPLATE_INSTANCES_SUCCESS = 'SI_GET_TEMPLATE_INSTANCES_SUCCESS';
type SI_GET_TEMPLATE_INSTANCES_SUCCESS_TYPE = 'SI_GET_TEMPLATE_INSTANCES_SUCCESS';

export const SI_GET_TEMPLATE_INSTANCES_FAILURE = 'SI_GET_TEMPLATE_INSTANCES_FAILURE';
type SI_GET_TEMPLATE_INSTANCES_FAILURE_TYPE = 'SI_GET_TEMPLATE_INSTANCES_FAILURE';

type SIGetTemplateInstancesRequestAction = Action<SI_GET_TEMPLATE_INSTANCES_REQUEST_TYPE, null>;

type SIGetTemplateInstancesSuccessAction = Action<
  SI_GET_TEMPLATE_INSTANCES_SUCCESS_TYPE,
  { data: any }
>;

type SIGetTemplateInstancesFailureAction = Action<
  SI_GET_TEMPLATE_INSTANCES_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Add created template instance
export const SI_ADD_CREATED_TEMPLATE_INSTANCE = 'SI_ADD_CREATED_TEMPLATE_INSTANCE';
type SI_ADD_CREATED_TEMPLATE_INSTANCE_TYPE = 'SI_ADD_CREATED_TEMPLATE_INSTANCE';
type SIAddCreatedTemplateInstanceAction = Action<SI_ADD_CREATED_TEMPLATE_INSTANCE_TYPE, null>;

// Template instance
export const SI_GET_TEMPLATE_INSTANCE_REQUEST = 'SI_GET_TEMPLATE_INSTANCE_REQUEST';
type SI_GET_TEMPLATE_INSTANCE_REQUEST_TYPE = 'SI_GET_TEMPLATE_INSTANCE_REQUEST';

export const SI_GET_TEMPLATE_INSTANCE_SUCCESS = 'SI_GET_TEMPLATE_INSTANCE_SUCCESS';
type SI_GET_TEMPLATE_INSTANCE_SUCCESS_TYPE = 'SI_GET_TEMPLATE_INSTANCE_SUCCESS';

export const SI_GET_TEMPLATE_INSTANCE_FAILURE = 'SI_GET_TEMPLATE_INSTANCE_FAILURE';
type SI_GET_TEMPLATE_INSTANCE_FAILURE_TYPE = 'SI_GET_TEMPLATE_INSTANCE_FAILURE';

type SIGetTemplateInstanceRequestAction = Action<SI_GET_TEMPLATE_INSTANCE_REQUEST_TYPE, null>;

type SIGetTemplateInstanceSuccessAction = Action<
  SI_GET_TEMPLATE_INSTANCE_SUCCESS_TYPE,
  { data: any }
>;

type SIGetTemplateInstanceFailureAction = Action<
  SI_GET_TEMPLATE_INSTANCE_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

export const UPDATE_WIDGET_INSTANCE_TEMPLATE_REQUEST = 'UPDATE_WIDGET_INSTANCE_TEMPLATE_REQUEST';

export const UPDATE_WIDGET_INSTANCE_TEMPLATE_SUCCESS = 'UPDATE_WIDGET_INSTANCE_TEMPLATE_SUCCESS';

export const UPDATE_WIDGET_INSTANCE_TEMPLATE_FAILURE = 'UPDATE_WIDGET_INSTANCE_TEMPLATE_SUCCESS';

// Clone Boost template instance
export const SI_CLONE_BOOST_TEMPLATES_REQUEST = 'SI_CLONE_BOOST_TEMPLATES_REQUEST';
type SI_CLONE_BOOST_TEMPLATES_REQUEST_TYPE = 'SI_CLONE_BOOST_TEMPLATES_REQUEST';

export const SI_CLONE_BOOST_TEMPLATES_SUCCESS = 'SI_CLONE_BOOST_TEMPLATES_SUCCESS';
type SI_CLONE_BOOST_TEMPLATES_SUCCESS_TYPE = 'SI_CLONE_BOOST_TEMPLATES_SUCCESS';

export const SI_CLONE_BOOST_TEMPLATES_FAILURE = 'SI_CLONE_BOOST_TEMPLATES_FAILURE';
type SI_CLONE_BOOST_TEMPLATES_FAILURE_TYPE = 'SI_CLONE_BOOST_TEMPLATES_FAILURE';

type SICloneBoostTemplatesRequestAction = Action<SI_CLONE_BOOST_TEMPLATES_REQUEST_TYPE, null>;

type SICloneBoostTemplatesSuccessAction = Action<
  SI_CLONE_BOOST_TEMPLATES_SUCCESS_TYPE,
  { data: any }
>;

type SICloneBoostTemplatesFailureAction = Action<
  SI_CLONE_BOOST_TEMPLATES_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Rename template instance
export const SI_RENAME_TEMPLATES_REQUEST = 'SI_RENAME_TEMPLATES_REQUEST';
type SI_RENAME_TEMPLATES_REQUEST_TYPE = 'SI_RENAME_TEMPLATES_REQUEST';

export const SI_RENAME_TEMPLATES_SUCCESS = 'SI_RENAME_TEMPLATES_SUCCESS';
type SI_RENAME_TEMPLATES_SUCCESS_TYPE = 'SI_RENAME_TEMPLATES_SUCCESS';

export const SI_RENAME_TEMPLATES_FAILURE = 'SI_RENAME_TEMPLATES_FAILURE';
type SI_RENAME_TEMPLATES_FAILURE_TYPE = 'SI_RENAME_TEMPLATES_FAILURE';

type SIRenameTemplatesRequestAction = Action<SI_RENAME_TEMPLATES_REQUEST_TYPE, null>;

type SIRenameTemplatesSuccessAction = Action<SI_RENAME_TEMPLATES_SUCCESS_TYPE, { data: any }>;

type SIRenameTemplatesFailureAction = Action<
  SI_RENAME_TEMPLATES_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Rename template instance
export const SI_REMOVE_TEMPLATE_REQUEST = 'SI_REMOVE_TEMPLATE_REQUEST';
type SI_REMOVE_TEMPLATE_REQUEST_TYPE = 'SI_REMOVE_TEMPLATE_REQUEST';

export const SI_REMOVE_TEMPLATE_SUCCESS = 'SI_REMOVE_TEMPLATE_SUCCESS';
type SI_REMOVE_TEMPLATE_SUCCESS_TYPE = 'SI_REMOVE_TEMPLATE_SUCCESS';

export const SI_REMOVE_TEMPLATE_FAILURE = 'SI_REMOVE_TEMPLATE_FAILURE';
type SI_REMOVE_TEMPLATE_FAILURE_TYPE = 'SI_REMOVE_TEMPLATE_FAILURE';

type SIRemoveTemplateRequestAction = Action<SI_REMOVE_TEMPLATE_REQUEST_TYPE, null>;

type SIRemoveTemplateSuccessAction = Action<SI_REMOVE_TEMPLATE_SUCCESS_TYPE, { data: any }>;

type SIRemoveTemplateFailureAction = Action<
  SI_REMOVE_TEMPLATE_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Duplicate template instance
export const SI_DUPLICATE_TEMPLATE_REQUEST = 'SI_DUPLICATE_TEMPLATE_REQUEST';
type SI_DUPLICATE_TEMPLATE_REQUEST_TYPE = 'SI_DUPLICATE_TEMPLATE_REQUEST';

export const SI_DUPLICATE_TEMPLATE_SUCCESS = 'SI_DUPLICATE_TEMPLATE_SUCCESS';
type SI_DUPLICATE_TEMPLATE_SUCCESS_TYPE = 'SI_DUPLICATE_TEMPLATE_SUCCESS';

export const SI_DUPLICATE_TEMPLATE_FAILURE = 'SI_DUPLICATE_TEMPLATE_FAILURE';
type SI_DUPLICATE_TEMPLATE_FAILURE_TYPE = 'SI_DUPLICATE_TEMPLATE_FAILURE';

type SIDuplicateTemplateRequestAction = Action<SI_DUPLICATE_TEMPLATE_REQUEST_TYPE, null>;

type SIDuplicateTemplateSuccessAction = Action<SI_DUPLICATE_TEMPLATE_SUCCESS_TYPE, { data: any }>;

type SIDuplicateTemplateFailureAction = Action<
  SI_DUPLICATE_TEMPLATE_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Cleanup state when exiting Manage template page
export const SI_CLEAN_STATE_EXIT_MANAGE_TEMPLATE_PAGE = 'SI_CLEAN_STATE_EXIT_MANAGE_TEMPLATE_PAGE';
type SI_CLEAN_STATE_EXIT_MANAGE_TEMPLATE_PAGE_TYPE = 'SI_CLEAN_STATE_EXIT_MANAGE_TEMPLATE_PAGE';
type SICleanStateExitManageTemplatePageAction = Action<
  SI_CLEAN_STATE_EXIT_MANAGE_TEMPLATE_PAGE_TYPE,
  null
>;

export const UPDATE_FIELD = `SI_UPDATE_FIELD`;
type UPDATE_FIELD_TYPE = 'SI_UPDATE_FIELD';
type UpdateFieldAction = Action<UPDATE_FIELD_TYPE, any>;

export const UPDATE_MULTI_FIELDS = 'SI_UPDATE_MULTI_FIELDS';
type UPDATE_MULTI_FIELDS_TYPE = 'SI_UPDATE_MULTI_FIELDS';
type UpdateMultiFieldsAction = Action<UPDATE_MULTI_FIELDS_TYPE, any>;

// Update themeIds of template
export const SI_UPDATE_THEME_IDS_OF_TEMPLATE = 'SI_UPDATE_THEME_IDS_OF_TEMPLATE';
type SI_UPDATE_THEME_IDS_OF_TEMPLATE_TYPE = 'SI_UPDATE_THEME_IDS_OF_TEMPLATE';
type SIUpdateThemeIdsOfTemplateAction = Action<
  SI_UPDATE_THEME_IDS_OF_TEMPLATE_TYPE,
  { payload: any }
>;

// Get widget versions
export const SI_GET_WIDGET_VERSIONS_REQUEST = 'SI_GET_WIDGET_VERSIONS_REQUEST';
type SI_GET_WIDGET_VERSIONS_REQUEST_TYPE = 'SI_GET_WIDGET_VERSIONS_REQUEST';

export const SI_GET_WIDGET_VERSIONS_SUCCESS = 'SI_GET_WIDGET_VERSIONS_SUCCESS';
type SI_GET_WIDGET_VERSIONS_SUCCESS_TYPE = 'SI_GET_WIDGET_VERSIONS_SUCCESS';

export const SI_GET_WIDGET_VERSIONS_FAILURE = 'SI_GET_WIDGET_VERSIONS_FAILURE';
type SI_GET_WIDGET_VERSIONS_FAILURE_TYPE = 'SI_GET_WIDGET_VERSIONS_FAILURE';

type SIGetWidgetVersionsRequestAction = Action<SI_GET_WIDGET_VERSIONS_REQUEST_TYPE, null>;

type SIGetWidgetVersionsSuccessAction = Action<SI_GET_WIDGET_VERSIONS_SUCCESS_TYPE, { data: any }>;

type SIGetWidgetVersionsFailureAction = Action<
  SI_GET_WIDGET_VERSIONS_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Get widget versions content
export const SI_GET_WIDGET_VERSIONS_CONTENT_REQUEST = 'SI_GET_WIDGET_VERSIONS_CONTENT_REQUEST';
type SI_GET_WIDGET_VERSIONS_CONTENT_REQUEST_TYPE = 'SI_GET_WIDGET_VERSIONS_CONTENT_REQUEST';

export const SI_GET_WIDGET_VERSIONS_CONTENT_SUCCESS = 'SI_GET_WIDGET_VERSIONS_CONTENT_SUCCESS';
type SI_GET_WIDGET_VERSIONS_CONTENT_SUCCESS_TYPE = 'SI_GET_WIDGET_VERSIONS_CONTENT_SUCCESS';

export const SI_GET_WIDGET_VERSIONS_CONTENT_FAILURE = 'SI_GET_WIDGET_VERSIONS_CONTENT_FAILURE';
type SI_GET_WIDGET_VERSIONS_CONTENT_FAILURE_TYPE = 'SI_GET_WIDGET_VERSIONS_CONTENT_FAILURE';

type SIGetWidgetVersionsContentRequestAction = Action<
  SI_GET_WIDGET_VERSIONS_CONTENT_REQUEST_TYPE,
  null
>;

type SIGetWidgetVersionsContentSuccessAction = Action<
  SI_GET_WIDGET_VERSIONS_CONTENT_SUCCESS_TYPE,
  { templateInstance: any }
>;

type SIGetWidgetVersionsContentFailureAction = Action<
  SI_GET_WIDGET_VERSIONS_CONTENT_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Check template instance upgradeable
export const SI_CHECK_TEMPLATE_UPGRADEABLE_REQUEST = 'SI_CHECK_TEMPLATE_UPGRADEABLE_REQUEST';
type SI_CHECK_TEMPLATE_UPGRADEABLE_REQUEST_TYPE = 'SI_CHECK_TEMPLATE_UPGRADEABLE_REQUEST';

export const SI_CHECK_TEMPLATE_UPGRADEABLE_SUCCESS = 'SI_CHECK_TEMPLATE_UPGRADEABLE_SUCCESS';
type SI_CHECK_TEMPLATE_UPGRADEABLE_SUCCESS_TYPE = 'SI_CHECK_TEMPLATE_UPGRADEABLE_SUCCESS';

export const SI_CHECK_TEMPLATE_UPGRADEABLE_FAILURE = 'SI_CHECK_TEMPLATE_UPGRADEABLE_FAILURE';
type SI_CHECK_TEMPLATE_UPGRADEABLE_FAILURE_TYPE = 'SI_CHECK_TEMPLATE_UPGRADEABLE_FAILURE';

type SICheckTemplateUpgradeableRequestAction = Action<
  SI_CHECK_TEMPLATE_UPGRADEABLE_REQUEST_TYPE,
  null
>;

type SICheckTemplateUpgradeableSuccessAction = Action<
  SI_CHECK_TEMPLATE_UPGRADEABLE_SUCCESS_TYPE,
  { templateInstance: any }
>;

type SICheckTemplateUpgradeableFailureAction = Action<
  SI_CHECK_TEMPLATE_UPGRADEABLE_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Add latest template
export const SI_ADD_UPGRADED_TEMPLATE_REQUEST = 'SI_ADD_UPGRADED_TEMPLATE_REQUEST';
type SI_ADD_UPGRADED_TEMPLATE_REQUEST_TYPE = 'SI_ADD_UPGRADED_TEMPLATE_REQUEST';

export const SI_ADD_UPGRADED_TEMPLATE_SUCCESS = 'SI_ADD_UPGRADED_TEMPLATE_SUCCESS';
type SI_ADD_UPGRADED_TEMPLATE_SUCCESS_TYPE = 'SI_ADD_UPGRADED_TEMPLATE_SUCCESS';

export const SI_ADD_UPGRADED_TEMPLATE_FAILURE = 'SI_ADD_UPGRADED_TEMPLATE_FAILURE';
type SI_ADD_UPGRADED_TEMPLATE_FAILURE_TYPE = 'SI_ADD_UPGRADED_TEMPLATE_FAILURE';

type SIAddUpgradedTemplateRequestAction = Action<SI_ADD_UPGRADED_TEMPLATE_REQUEST_TYPE, null>;

type SIAddUpgradedTemplateSuccessAction = Action<
  SI_ADD_UPGRADED_TEMPLATE_SUCCESS_TYPE,
  { templateInstance: any }
>;

type SIAddUpgradedTemplateFailureAction = Action<
  SI_ADD_UPGRADED_TEMPLATE_FAILURE_TYPE,
  SITemplateInstanceFailure
>;

// Boost template instance
export const SI_COUNT_TEMPLATES_REQUEST = 'SI_COUNT_TEMPLATES_REQUEST';
type SI_COUNT_TEMPLATES_REQUEST_TYPE = 'SI_COUNT_TEMPLATES_REQUEST';

export const SI_COUNT_TEMPLATES_SUCCESS = 'SI_COUNT_TEMPLATES_SUCCESS';
type SI_COUNT_TEMPLATES_SUCCESS_TYPE = 'SI_COUNT_TEMPLATES_SUCCESS';

export const SI_COUNT_TEMPLATES_FAILURE = 'SI_COUNT_TEMPLATES_FAILURE';
type SI_COUNT_TEMPLATES_FAILURE_TYPE = 'SI_COUNT_TEMPLATES_FAILURE';

type SICountTemplatesRequestAction = Action<SI_COUNT_TEMPLATES_REQUEST_TYPE, null>;

type SICountTemplatesSuccessAction = Action<SI_COUNT_TEMPLATES_SUCCESS_TYPE, number>;

type SICountTemplatesFailureAction = Action<
  SI_COUNT_TEMPLATES_FAILURE_TYPE,
  SITemplateInstanceFailure
>;
export type SITemplateInstanceAction =
  | SIGetBoostTemplatesRequestAction
  | SIGetBoostTemplatesSuccessAction
  | SIGetBoostTemplatesFailureAction
  | SIGetTemplateInstancesRequestAction
  | SIGetTemplateInstancesSuccessAction
  | SIGetTemplateInstancesFailureAction
  | SIAddCreatedTemplateInstanceAction
  | SIGetTemplateInstanceRequestAction
  | SIGetTemplateInstanceSuccessAction
  | SIGetTemplateInstanceFailureAction
  | SICloneBoostTemplatesRequestAction
  | SICloneBoostTemplatesSuccessAction
  | SICloneBoostTemplatesFailureAction
  | SIRenameTemplatesRequestAction
  | SIRenameTemplatesSuccessAction
  | SIRenameTemplatesFailureAction
  | SIRemoveTemplateRequestAction
  | SIRemoveTemplateSuccessAction
  | SIRemoveTemplateFailureAction
  | SIDuplicateTemplateRequestAction
  | SIDuplicateTemplateSuccessAction
  | SIDuplicateTemplateFailureAction
  | SICleanStateExitManageTemplatePageAction
  | UpdateFieldAction
  | UpdateMultiFieldsAction
  | SIUpdateThemeIdsOfTemplateAction
  | SIGetWidgetVersionsRequestAction
  | SIGetWidgetVersionsSuccessAction
  | SIGetWidgetVersionsFailureAction
  | SIGetWidgetVersionsContentRequestAction
  | SIGetWidgetVersionsContentSuccessAction
  | SIGetWidgetVersionsContentFailureAction
  | SICheckTemplateUpgradeableRequestAction
  | SICheckTemplateUpgradeableSuccessAction
  | SICheckTemplateUpgradeableFailureAction
  | SIAddUpgradedTemplateRequestAction
  | SIAddUpgradedTemplateSuccessAction
  | SIAddUpgradedTemplateFailureAction
  | SICountTemplatesRequestAction
  | SICountTemplatesSuccessAction
  | SICountTemplatesFailureAction;

export type SITemplateInstanceState = {
  getBoostTemplatesLoading: boolean,
  getBoostTemplatesSuccess: Boolean,
  boostTemplates: [],

  getTemplateInstanceLoading: Boolean,
  getTemplateInstanceSuccess: Boolean,
  templateInstances: [],

  cloneBoostTemplatesLoading: boolean,
  cloneBoostTemplatesSuccess: Boolean,
  clonedTemplateInstance: {},

  renameTemplatesLoading: boolean,
  renameTemplatesSuccess: Boolean,
  renamedTemplateInstance: {},

  removeTemplateLoading: boolean,
  removeTemplateSuccess: Boolean,
  removedTemplateInstance: {},

  duplicateTemplateLoading: boolean,
  duplicateTemplateSuccess: Boolean,
  duplicatedTemplateInstance: {}
};

export const TEMPLATE_UPGRADE_STATUS = {
  UPGRADE_ALLOWED: 'UPGRADE_ALLOWED',
  UPGRADE_NOT_ALLOWED: 'UPGRADE_NOT_ALLOWED'
};
